import {appraisalTemplateQuestionTypes} from 'constants';

export default {
  props: {
    questions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      questionTypes: appraisalTemplateQuestionTypes,
      requiredRule: [{name: 'required'}],
      errors: {},
      hasAttemptedValidation: false
    };
  },
  computed: {
    answerLabel() {
      return this.$t('models.appraisal.attributes.answer');
    },
    answerRequiredMessage() {
      return this.$t('messages.error.required', {entity: this.answerLabel});
    }
  },
  methods: {
    buildDefaultAnswers(value) {
      return this.questions.reduce((answers, question) => {
        if (!(question.id in answers)) {
          answers[question.id] = '';
        }
        return answers;
      }, {...value});
    },
    isQuestionAnswered(question) {
      return !!this.localAnswers[question.id];
    },
    validate() {
      this.hasAttemptedValidation = true;
      const valid = this.$refs.form.validate();
      this.refreshErrors();
      return valid;
    }
  }
};
